import styled from 'styled-components';

export const FormContainer = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing[7]}px;
`,
);
